import { Music, Zap, ScrollText, RefreshCw, Lock, ShieldCheck, Download, Loader2, Check, Sparkles } from "lucide-react";

const INCLUDES = [
  { icon: Music, text: "Your chosen Main Jingle — the clean 30-second studio master (WAV)" },
  { icon: Zap, text: "Short Hook — a punchy audio logo-stinger cut for the end of commercials, Reels, TikTok & Shorts and more" },
  { icon: ScrollText, text: "Unlimited Lifetime Commercial Rights (radio, TV, web, social, on-hold, or ANYWHERE else you want to use it)" },
];

export const OfferStackCard = ({ onCheckout, loading, bumpChecked, onBumpToggle, takeName, creditsCents = 0, extrasCount = 0, testIdPrefix = "offer" }) => {
  const credits = creditsCents / 100;
  const base = Math.max(0, 197 - credits);
  const freeUnlock = credits >= 197 && !bumpChecked && extrasCount === 0;
  const total = freeUnlock ? 0 : base + (bumpChecked ? 47 : 0) + extrasCount * 17;
  return (
    <div
      data-testid={`${testIdPrefix}-card`}
      className="relative rounded-3xl border border-gold/40 bg-ink p-6 sm:p-7 shadow-[0_0_60px_rgba(255,183,3,0.12)] overflow-hidden"
    >
      <div className="absolute -top-24 -right-24 h-64 w-64 rounded-full bg-gold/10 blur-3xl pointer-events-none" />
      <h2 data-testid={`${testIdPrefix}-headline`} className="relative font-display text-xl sm:text-2xl font-bold tracking-tight mb-4 leading-snug">
        Your Selected Download Options:
      </h2>
      <div className="flex flex-wrap items-end gap-3 mb-1.5">
        <span className="font-display text-4xl sm:text-5xl font-extrabold text-gold tracking-tight">
          ${freeUnlock ? 0 : total}
        </span>
        {credits > 0 ? (
          <span className="text-slate-500 line-through text-lg mb-1.5">$197</span>
        ) : (
          <span className="text-slate-500 line-through text-lg mb-1.5">$1,497 value</span>
        )}
        <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-black bg-gold rounded-full px-3 py-1.5 mb-2">
          One-time payment
        </span>
      </div>
      {credits > 0 && (
        <p data-testid={`${testIdPrefix}-credits-note`} className="flex items-center gap-2 text-sm text-emerald-400 font-semibold mb-1.5">
          <Sparkles className="h-4 w-4" /> ${credits.toFixed(0)} in preview credits applied automatically
        </p>
      )}
      <p className="text-slate-400 text-sm mb-2">
        Pay once, own it forever.
      </p>
      {takeName && (
        <p data-testid={`${testIdPrefix}-take-locked`} className="font-mono text-xs uppercase tracking-[0.2em] text-neon mb-4">
          Locked in: {takeName}
        </p>
      )}
      {extrasCount > 0 && (
        <p data-testid={`${testIdPrefix}-extras-note`} className="flex items-center gap-2 text-sm text-neon font-semibold mb-4">
          <Check className="h-4 w-4" /> +{extrasCount} bonus take{extrasCount === 1 ? "" : "s"} (${extrasCount * 17}) — clean, no watermark
        </p>
      )}
      <ul className="space-y-2.5 mb-4">
        {INCLUDES.map((item, i) => (
          <li key={i} className="flex items-start gap-3">
            <span className="mt-0.5 h-6 w-6 shrink-0 rounded-lg bg-gold/10 border border-gold/30 flex items-center justify-center">
              <item.icon className="h-3 w-3 text-gold" />
            </span>
            <span className="text-sm text-slate-200 leading-snug">{item.text}</span>
          </li>
        ))}
      </ul>
      <button
        type="button"
        data-testid={`${testIdPrefix}-bump-toggle`}
        onClick={onBumpToggle}
        className={`w-full text-left rounded-2xl border-2 border-dashed p-3.5 sm:p-4 mb-5 transition-all cursor-pointer ${
          bumpChecked ? "border-coral bg-coral/10" : "border-white/20 bg-obsidian/50 hover:border-coral/50"
        }`}
      >
        <span className="flex items-start gap-3">
          <span className={`mt-0.5 h-5 w-5 shrink-0 rounded-md border-2 flex items-center justify-center transition-colors ${
            bumpChecked ? "border-coral bg-coral" : "border-white/30"
          }`}>
            {bumpChecked && <Check className="h-3.5 w-3.5 text-white" />}
          </span>
          <span className="flex-1">
            <span className="flex items-center justify-between gap-3">
              <span className="font-display font-bold text-sm text-white">
                YES — add my instrumental musical bed for commercials and hold music
              </span>
              <span className="font-display font-extrabold text-coral shrink-0">+$47</span>
            </span>
            <span className="block text-xs text-slate-400 mt-1 leading-snug">
              A custom musical bed — 100% unique in your jingle's style — the perfect
              background music for commercials, videos, and even on-hold music.
            </span>
          </span>
        </span>
      </button>
      <button
        data-testid={`${testIdPrefix}-checkout-btn`}
        onClick={onCheckout}
        disabled={loading}
        className="w-full bg-gradient-to-r from-gold to-[#FB8500] text-black font-extrabold text-base sm:text-lg px-8 py-4 rounded-xl shadow-[0_0_36px_rgba(255,183,3,0.4)] hover:scale-[1.02] active:scale-[0.98] transition-transform duration-200 cursor-pointer disabled:opacity-70 disabled:cursor-wait flex items-center justify-center gap-2.5"
      >
        {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : freeUnlock ? <Sparkles className="h-5 w-5" /> : <Lock className="h-5 w-5" />}
        {loading ? "Opening secure checkout..." : freeUnlock ? "UNLOCK FREE — YOUR CREDITS COVERED IT" : `GET MY JINGLE — $${total}`}
      </button>
      <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 mt-5 text-xs text-slate-500">
        <span className="flex items-center gap-1.5"><ShieldCheck className="h-3.5 w-3.5 text-emerald-400" /> Stripe 256-bit SSL</span>
        <span className="flex items-center gap-1.5"><Download className="h-3.5 w-3.5 text-emerald-400" /> Instant download</span>
        <span className="flex items-center gap-1.5"><RefreshCw className="h-3.5 w-3.5 text-emerald-400" /> 100% satisfaction guarantee</span>
      </div>
      <p className="mt-4 text-center text-[11px] text-slate-600 leading-relaxed">
        By checking out you agree we may charge this card for optional add-ons you
        explicitly approve with one click afterward. No surprises — nothing charges without your click.
      </p>
    </div>
  );
};
